/*
 * @Author: bianbinbin
 * @Date: 2023-12-27 15:31:33
 * @LastEditors: bianbinbin
 * @LastEditTime: 2023-12-27 16:15:51
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/banner-or-board.js
 */
const bannerOrBoard = r =>
  require.ensure([], () => r(require('@/views/bannerOrBoard/bannerOrBoard.vue'), 'bannerOrBoard'))

const router = [
  {
    path: '/bannerOrBoard',
    name: 'bannerOrBoard',
    meta: {
      title: ''
    },
    component: bannerOrBoard
  }
]

export default router
